import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { getDispatchCustomerFacets } from "../services";

export const useCustomerFacets = (
  customerFilter: string = "all",
  isApiConfigReady: boolean = false,
  activeTab?: string,
  refetchIntervalMs?: number,
  supplierId?: string
) => {
  const { data, isLoading, refetch, dataUpdatedAt } = useQuery({
    queryKey: ["customerFacets", activeTab, supplierId],
    queryFn: () =>
      getDispatchCustomerFacets({}, activeTab, supplierId),
    enabled: isApiConfigReady,
    staleTime: refetchIntervalMs || 10 * 60 * 1000,
    refetchInterval: false,
    refetchOnWindowFocus: false,
  });
  
  const filteredCustomers = useMemo(() => {
    return (
      data?.customers?.filter((customer: any) => {
        const matchesCustomerFilter =
          customerFilter === "all" || customerFilter === customer._id;
        return matchesCustomerFilter;
      }) || []
    );
  }, [data?.customers, customerFilter]);

  return {
    facets: data,
    loading: isLoading,
    filteredCustomers,
    refetch,
    dataUpdatedAt,
  };
};
